import {
  ListScheduledNotifications,
  ListScheduledNotificationsVariables
} from './__generated__/ListScheduledNotifications'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListScheduledNotifications($input: ListScheduledNotificationInputV2!) {
    listScheduledNotifications: listScheduledNotificationsV2(input: $input) {
      nextCursor
      scheduledNotifications {
        id
        createdAt
        sendAt
        message
        title
        callToAction
        deepLink
        numberOpened
        numberClicked
        numberAttempted
        numberDelivered
        tag {
          id
          title
        }
        segments {
          id
          title
        }
      }
    }
  }
`

export const useListScheduledNotifications = (variables: ListScheduledNotificationsVariables) => {
  return useQuery<ListScheduledNotifications, ListScheduledNotificationsVariables>(QUERY, {
    variables,
    fetchPolicy: 'network-only'
  })
}

useListScheduledNotifications.QUERY = QUERY
